module.exports = __webpack_public_path__ + "img/44.036890cd.png";